export enum InternalTransferDetails {
  DepositToBalance = 'deposit_to_balance',
  BalanceToDeposit = 'balance_to_deposit',
}
